import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { DataGridSetting } from "../../../../components";
import { Button } from "../../../../shared";
import { useOrganization } from "../../../../hooks/query";

import { columnDef } from "./column-def";
import { StatusCellRenderer } from "./GridFrameworks";
import Breadcrumb from "./Breadcrumb";

import type { IOrganization } from "../../../../interfaces";

export default function List() {
    const { useList } = useOrganization();
    const { data, isLoading, isError, error } = useList();

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load organizations"}
                </Box>
            </Box>
        );
    }

    const organizations = (data as IOrganization[]) || [];

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={organizations}
                    columnDefs={columnDef.map((col) => {
                        if (col.cellRenderer === "StatusCellRenderer") {
                            return { ...col, cellRenderer: StatusCellRenderer };
                        }
                        return col;
                    })}
                    quickControlStartDecorator={<CreateOrganizationButton />}
                />
            </Box>
        </Box>
    );
}

function CreateOrganizationButton() {
    return (
        <Box display="flex" alignItems={"center"} ml={1.5}>
            <Button
                variant="soft"
                color="primary"
                component={Link}
                to="/admin/organizations/create"
                startDecorator={<Plus size={18} />}
            >
                Create Organization
            </Button>
            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
        </Box>
    );
}
